import { KOR_SPONSOR_PARENT_ACCOUNT_ID } from '@shared/constants';

/**
 * Whether a Business Account is a tenant root rather than a child.
 *
 * Mirrors the backend definition of a root account (`parent_id IS NULL OR parent_id = <KOR sponsor>`): a tenant root
 * hangs off the KOR sponsor account, while a child Business Account points at its tenant.
 */
export const isTenantBusinessAccount = (parentId?: string): boolean => !parentId || parentId === KOR_SPONSOR_PARENT_ACCOUNT_ID;
